export default __webpack_public_path__ + "static/media/Average area.723f79db.gif";